export class TimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';
    // Need to explicitly set this for transpilation to older
    // JS versions.
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }
}

/**
 * Executes a Promise with a timeout.
 *
 * `timeoutMessage` names what timed out, so a caller's error reads usefully
 * rather than as a generic timeout.
 */
export async function executeWithTimeout<T>(
  promise: Promise<T>,
  timeout: number,
  timeoutMessage = 'Promise timed out.',
): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new TimeoutError(timeoutMessage));
    }, timeout);

    promise
      .then((result) => {
        clearTimeout(timer);
        resolve(result);
      })
      .catch((error: unknown) => {
        clearTimeout(timer);
        reject(error instanceof Error ? error : new Error(String(error)));
      });
  });
}
